import React from 'react';

import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';

import timePickerStyles from '../assets/jss/crm/components/timePickerStyles';

class TimePicker extends React.Component {
  state = {
    shouldShowTimeOptions: false,
  };

  generateTimeOptionsList(classes) {
    const timeStrs = [];
    for (let i = 0; i < 48; i++) {
      const milHour = 7 + Math.floor(i / 2);
      let hour = milHour > 12 ? milHour - 12 : milHour;
      if (hour > 12) hour -= 12;
      const min = i & 1 ? '30' : '00';
      const ampm = milHour >= 12 && milHour < 24 ? 'PM' : 'AM';
      const timeStr = `${hour}:${min} ${ampm}`;
      timeStrs.push(timeStr);
    }
    const items = timeStrs.map((str, i) => (
      <li key={i} className={classes.optionListItem}>
        {str}
      </li>
    ));

    return <ul>{items}</ul>;
  }

  handleTimeTextChange(event) {
    this.props.onChange(event.target.value);
  }

  handleTimeOptionClick(event) {
    this.props.onChange(event.target.innerText);
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.typeahead}>
        <div className={classes.typeahead_header}>
          <div className={classes.validatedTextField}>
            <TextField
              variant="standard"
              onFocus={() => this.setState({ shouldShowTimeOptions: true })}
              onBlur={() => setTimeout(() => this.setState({ shouldShowTimeOptions: false }), 200)}
              id="textfield-time"
              value={this.props.value}
              onChange={(event) => this.handleTimeTextChange(event)}
              margin="normal"
              InputProps={{ className: classes.inputProps }}
            />
          </div>
        </div>
        {this.state.shouldShowTimeOptions && (
          <div className={classes.typeahead_options}>
            <div className={classes.optionList} onClick={(event) => this.handleTimeOptionClick(event)}>
              {this.generateTimeOptionsList(classes)}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(timePickerStyles)(TimePicker);
